
export function smoothScroll() {
    // The document position that puts the target just below the header. Read
    // fresh every time it is needed rather than once per click: the whole
    // problem this file now guards against is that it CHANGES.
    const desiredTop = (target, offset) =>
        target.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        (offset + 20);

    const offsetFor = (anchor) =>
        (document.querySelector('.header')?.offsetHeight || 0) +
        parseInt(anchor.getAttribute('data-smooth-scroll-offset') || 0);

    document.querySelectorAll('a[data-smooth-scroll]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const target = document.querySelector(this.getAttribute('href'));

            if (!target) {
                return;
            }

            window.scrollTo({ behavior: 'smooth', top: desiredTop(target, offsetFor(this)) });

            /**
             * CONTENT ABOVE THE TARGET CAN STILL BE ARRIVING.
             *
             * A smooth scroll is aimed at a pixel position computed at the
             * moment of the click. On a slow connection the property page is
             * still assembling: <enquiryform> mounts late and grows by most of
             * a screen, and it sits directly above the Location map. Whatever
             * was measured is then wrong - and if the growth lands AFTER the
             * animation has finished, the browser's own scroll anchoring
             * pushes the viewport down to keep the visible content still,
             * carrying the reader straight past what they clicked for. Seen
             * live on Silverholme Manor and Dabton House, twice, on 5G.
             *
             * So re-measure for a beat and correct. Aiming at an ELEMENT
             * rather than at a number that was true once.
             *
             * Abandoned the instant the reader scrolls themselves: they have
             * taken over, and yanking the page back would be worse than
             * landing in the wrong place.
             */
            let cancelled = false;
            let attempts = 0;

            const abandon = () => {
                cancelled = true;
            };

            const events = ['wheel', 'touchstart', 'keydown'];

            events.forEach((event) => window.addEventListener(event, abandon, { passive: true }));

            const finish = () => events.forEach((event) => window.removeEventListener(event, abandon));

            const settle = () => {
                if (cancelled || attempts >= 4) {
                    finish();

                    return;
                }

                attempts++;

                const want = desiredTop(target, offsetFor(this));

                // 4px of slack: sub-pixel rounding is not a layout shift, and
                // re-scrolling for it would look like a twitch.
                if (Math.abs(window.scrollY - want) > 4) {
                    window.scrollTo({ behavior: 'smooth', top: want });
                }

                window.setTimeout(settle, 350);
            };

            window.setTimeout(settle, 400);
        });
    });
}
